"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewerProvider = exports.ViewerContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var ViewerContext = _react["default"].createContext(undefined);

exports.ViewerContext = ViewerContext;

var ViewerProvider = function ViewerProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      viewer = _useState2[0],
      setViewer = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isReady = _useState4[0],
      setIsReady = _useState4[1];

  return _react["default"].createElement(ViewerContext.Provider, {
    value: (0, _react.useMemo)(function () {
      return {
        viewer: viewer,
        setViewer: setViewer,
        isReady: isReady,
        setIsReady: setIsReady
      };
    }, [isReady, viewer])
  }, children);
};

exports.ViewerProvider = ViewerProvider;